module.exports = __webpack_public_path__ + "static/media/background.fb0211d0.png";